let url = window.location.origin + '/api/';

class Utility {
    static get url() {
        return url;
    }
}

export default Utility;
